<div class="wil-content">
    <section class="wil-section bg-color-gray-2">
        <div class="container">
            <div class="wilcity-title-wrapper">
                <div class="heading_module__156eJ wil-text-center">
                    <h1 class="heading_title__1bzno">Add Event</h1>
                </div>
            </div>
            <div class="wil-addlisting row">
                <div class="col-md-12 col-lg-12 ">
                    <form (ngSubmit)="onSubmit()" [formGroup]="eventForm">

                        <div id="wilcity-addevent-basic" class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Basic Info</span>
                                    </h4>
                                </div>
                            </header>
                            <div class="content-box_body__3tSRB">
                                <mat-form-field>
                                    <mat-label>Title</mat-label>
                                    <input required matInput formControlName="title" />
                                </mat-form-field>
                                <!-- <mat-form-field>
                                    <mat-label>Description</mat-label>
                                    <textarea required matInput rows="5" formControlName="description"></textarea>
                                </mat-form-field> -->
                                <div class="job-description-ckeditor">
                                    <ckeditor [editor]="ckEditor" [config]="ckConfig" (ready)="onCkeditorReady($event)"
                                        formControlName="description"></ckeditor>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-basic -->

                        <div id="wilcity-addevent-times" class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Event Time & Date</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <!-- <mat-form-field>
                                        <mat-label>Event Type</mat-label>
                                        <mat-select formControlName="event_type">
                                            <mat-option value="one_time">One Time</mat-option>
                                            <mat-option value="recurrence">Recurrence</mat-option>
                                        </mat-select>
                                    </mat-form-field> -->

                                    <!-- time details for one time event -->
                                    <div *ngIf="eventForm.get('event_type').value == 'one_time'"
                                        class="event-wrapper-times-once">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <mat-form-field class="owldate-form-field">
                                                    <mat-label>Start Time</mat-label>
                                                    <!-- <input matInput formControlName="start_date"
                                                        [matDatepicker]="event_start_date"
                                                        (focus)="event_start_date.open()">
                                                    <mat-datepicker-toggle matSuffix [for]="event_start_date">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #event_start_date></mat-datepicker> -->

                                                    <input required matInput formControlName="start_time"
                                                        autocomplete="off" [owlDateTimeTrigger]="start_time"
                                                        [owlDateTime]="start_time" (focus)="start_time.open()">
                                                    <span class="owldate-trigger" [owlDateTimeTrigger]="start_time">
                                                        <i class="fa fa-calendar"></i>
                                                    </span>
                                                    <owl-date-time #start_time></owl-date-time>
                                                </mat-form-field>

                                            </div>
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>End Time</mat-label>
                                                    <input required matInput formControlName="end_time"
                                                        autocomplete="off" [owlDateTimeTrigger]="end_time"
                                                        [owlDateTime]="end_time" (focus)="end_time.open()">
                                                    <span class="owldate-trigger" [owlDateTimeTrigger]="end_time">
                                                        <i class="fa fa-calendar"></i>
                                                    </span>
                                                    <owl-date-time #end_time></owl-date-time>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <!-- <div class="row">
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>End Date</mat-label>
                                                    <input matInput formControlName="end_date"
                                                        [matDatepicker]="event_end_date"
                                                        (focus)="event_end_date.open()">
                                                    <mat-datepicker-toggle matSuffix [for]="event_end_date">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #event_end_date></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>End Time</mat-label>
                                                    <mat-select formControlName="end_time">
                                                        <mat-option *ngFor="let hour of hours" [value]="hour.value">
                                                            {{hour.viewValue}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div> -->
                                    </div>

                                    <!-- time details for recurrence event -->
                                    <div *ngIf="eventForm.get('event_type').value == 'recurrence'"
                                        class="event-wrapper-times-recurrence">
                                        <mat-form-field>
                                            <mat-label>Recurrence Type</mat-label>
                                            <mat-select formControlName="recurrence_type">
                                                <mat-option value="daily">Daily</mat-option>
                                                <mat-option value="weekly">Weekly</mat-option>
                                                <mat-option value="monthly">Monthly</mat-option>
                                                <mat-option value="yearly">Yearly</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Interval</mat-label>
                                            <mat-select formControlName="recurrence_interval">
                                                <mat-option value="1">1</mat-option>
                                                <mat-option value="2">2</mat-option>
                                                <mat-option value="3">3</mat-option>
                                                <mat-option value="4">4</mat-option>
                                                <mat-option value="5">5</mat-option>
                                                <mat-option value="6">6</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- days of week: show when weekly recurrence type is selected -->
                                        <mat-form-field *ngIf="eventForm.get('recurrence_type').value == 'weekly'">
                                            <mat-label>Days of Weeks</mat-label>
                                            <mat-select formControlName="days_of_weeks" multiple>
                                                <mat-option value="sunday">Sunday</mat-option>
                                                <mat-option value="monday">Monday</mat-option>
                                                <mat-option value="tuesday">Tuesday</mat-option>
                                                <mat-option value="wednesday">Wednesday</mat-option>
                                                <mat-option value="thursday">Thursday</mat-option>
                                                <mat-option value="friday">Friday</mat-option>
                                                <mat-option value="saturday">Saturday</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <!-- months of year: show when yearly recurrence type is selected -->
                                        <mat-form-field *ngIf="eventForm.get('recurrence_type').value == 'yearly'">
                                            <mat-label>Months of Year</mat-label>
                                            <mat-select formControlName="months_of_year" multiple>
                                                <mat-option value="1">January</mat-option>
                                                <mat-option value="2">February</mat-option>
                                                <mat-option value="3">March</mat-option>
                                                <mat-option value="4">April</mat-option>
                                                <mat-option value="5">May</mat-option>
                                                <mat-option value="6">June</mat-option>
                                                <mat-option value="7">July</mat-option>
                                                <mat-option value="8">August</mat-option>
                                                <mat-option value="9">September</mat-option>
                                                <mat-option value="10">October</mat-option>
                                                <mat-option value="11">November</mat-option>
                                                <mat-option value="12">December</mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <div class="row">
                                            <div class="col-md-6">

                                                <mat-form-field
                                                    *ngIf="eventForm.get('recurrence_type').value == '' || eventForm.get('recurrence_type').value == 'daily' || eventForm.get('recurrence_type').value == 'weekly'">
                                                    <mat-label>Start Date</mat-label>
                                                    <input matInput formControlName="rec_start_date"
                                                        [matDatepicker]="event_rec_start_date"
                                                        (focus)="event_rec_start_date.open()">
                                                    <mat-datepicker-toggle matSuffix [for]="event_rec_start_date">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #event_rec_start_date></mat-datepicker>
                                                </mat-form-field>

                                                <div *ngIf="eventForm.get('recurrence_type').value == 'monthly' || eventForm.get('recurrence_type').value == 'yearly'"
                                                    class="row">
                                                    <div
                                                        [ngClass]="rec_start_monthday.includes(eventForm.get('rec_start_monthday').value) ? 'col-md-6' : 'col-md-12'">
                                                        <mat-form-field>
                                                            <mat-label>Start Date</mat-label>
                                                            <mat-select formControlName="rec_start_monthday">
                                                                <mat-optgroup label="Use Pattern:">
                                                                    <mat-option value="1st">First</mat-option>
                                                                    <mat-option value="2nd">Second</mat-option>
                                                                    <mat-option value="3rd">Third</mat-option>
                                                                    <mat-option value="4th">Fourth</mat-option>
                                                                    <mat-option value="5th">Fifth</mat-option>
                                                                    <mat-option value="6th">Last</mat-option>
                                                                </mat-optgroup>
                                                                <mat-optgroup label="Use Date:">
                                                                    <mat-option
                                                                        *ngFor="let number of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                                                                        [value]="number">{{number}}</mat-option>
                                                                </mat-optgroup>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                    <div *ngIf="eventForm.get('rec_start_monthday').value == '1st' || eventForm.get('rec_start_monthday').value == '2nd' || eventForm.get('rec_start_monthday').value == '3rd' || eventForm.get('rec_start_monthday').value == '4th' || eventForm.get('rec_start_monthday').value == '5th' || eventForm.get('rec_start_monthday').value == '6th'"
                                                        class="col-md-6">
                                                        <mat-form-field>
                                                            <mat-label>Week Day</mat-label>
                                                            <mat-select formControlName="rec_start_weekday">
                                                                <mat-option value="sunday">Sunday</mat-option>
                                                                <mat-option value="monday">Monday</mat-option>
                                                                <mat-option value="tuesday">Tuesday</mat-option>
                                                                <mat-option value="wednesday">Wednesday</mat-option>
                                                                <mat-option value="thursday">Thursday</mat-option>
                                                                <mat-option value="friday">Friday</mat-option>
                                                                <mat-option value="saturday">Saturday</mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>Start Time</mat-label>
                                                    <mat-select formControlName="rec_start_time">
                                                        <mat-option *ngFor="let hour of hours" [value]="hour.value">
                                                            {{hour.viewValue}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>End Date</mat-label>
                                                    <mat-select formControlName="rec_end_date">
                                                        <mat-option value="0">same day</mat-option>
                                                        <mat-option value="1">next day</mat-option>
                                                        <mat-option value="2">2nd day</mat-option>
                                                        <mat-option value="3">3rd day</mat-option>
                                                        <mat-option value="4">4th day</mat-option>
                                                        <mat-option value="5">5th day</mat-option>
                                                        <mat-option value="6">6th day</mat-option>
                                                        <mat-option value="7">7th day</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>End Time</mat-label>
                                                    <mat-select formControlName="rec_end_time">
                                                        <mat-option *ngFor="let hour of hours" [value]="hour.value">
                                                            {{hour.viewValue}}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <mat-form-field>
                                                    <mat-label>Series Ends</mat-label>
                                                    <mat-select formControlName="series_end_type">
                                                        <mat-option value="after">After</mat-option>
                                                        <mat-option value="on">On</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                            <div class="col-md-6">
                                                <mat-form-field
                                                    *ngIf="eventForm.get('series_end_type').value == 'after'">
                                                    <mat-label>Number of Events</mat-label>
                                                    <input matInput formControlName="series_end_number" />
                                                </mat-form-field>
                                                <mat-form-field *ngIf="eventForm.get('series_end_type').value == 'on'">
                                                    <mat-label>Series Ends Date</mat-label>
                                                    <input matInput formControlName="series_end_date"
                                                        [matDatepicker]="event_series_end_date"
                                                        (focus)="event_series_end_date.open()">
                                                    <mat-datepicker-toggle matSuffix [for]="event_series_end_date">
                                                    </mat-datepicker-toggle>
                                                    <mat-datepicker #event_series_end_date></mat-datepicker>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-times -->

                        <div id="wilcity-addevent-featured_image"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS ">
                                        <span>Featured Image</span>
                                    </h4>
                                </div>
                            </header>
                            <div class="content-box_body__3tSRB">
                                <section class="section-mat-form-field section-field-file section-field-preview-img">
                                    <mat-label>Featured Image <span class="mat-form-field-required-marker">*</span>
                                    </mat-label>
                                    <input accept="image/*" type="file" formControlName="featured_img_input"
                                        #fileInputFeaturedImg (change)="onFeaturedImageChange($event)" />
                                    <span *ngIf="featuredImageSrc"
                                        [ngStyle]="{'background-image': 'url('+featuredImageSrc+')'}"></span>
                                    <a class="wil-btn wil-btn--primary wil-btn--round wil-btn--xxs"
                                        (click)="fileInputFeaturedImg.click()">Upload</a>
                                </section>
                                <mat-progress-bar *ngIf="progressFeaturedImg > 0" mode="determinate"
                                    [value]="progressFeaturedImg" class="mb-15"></mat-progress-bar>
                                <p class="form-error" *ngIf="!formCustomvalidation.featuredImage.validated">
                                    {{formCustomvalidation.featuredImage.message}}</p>
                            </div>
                        </div><!-- wilcity-addevent-featured_image -->

                        <div id="wilcity-addevent-category"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS ">
                                        <span>Event Category</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <mat-form-field>
                                        <mat-label>Select Categories</mat-label>
                                        <mat-select required
                                            (openedChange)="onSelectOpen($event, eventCategoryFilterInput)"
                                            formControlName="category_id" multiple>
                                            <input class="selectSearch" #eventCategoryFilterInput matInput
                                                placeholder="Search Categories" />
                                            <mat-option
                                                *ngFor="let option of filteredDropdownOptions(eventCategoryFilterInput.value, 'categories')"
                                                [value]="option.value">
                                                {{option.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-category -->

                        <div id="wilcity-addevent-tags" class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS ">
                                        <span>Event Tags</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <mat-form-field>
                                        <mat-label>Select Tags</mat-label>
                                        <mat-select (openedChange)="onSelectOpen($event, eventTagsFilterInput)"
                                            formControlName="tag_id" multiple>
                                            <input class="selectSearch" #eventTagsFilterInput matInput
                                                placeholder="Search Categories" />
                                            <mat-option
                                                *ngFor="let option of filteredDropdownOptions(eventTagsFilterInput.value, 'tags')"
                                                [value]="option.value">
                                                {{option.viewValue}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-tags -->

                        <div id="wilcity-addevent-address"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS "><span>Event
                                            Address</span></h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <mat-form-field>
                                        <mat-label>Venue Name</mat-label>
                                        <input [required]="!isVirtual" matInput formControlName="venue" />
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Full Address</mat-label>
                                        <input [required]="!isVirtual" matInput formControlName="address"
                                            (keydown)="locationModified = true" (blur)="onLocationBlur()" />
                                    </mat-form-field>
                                    <div class="row d-none">
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Latitude</mat-label>
                                                <input matInput formControlName="latitude" />
                                            </mat-form-field>
                                        </div>
                                        <div class="col-md-6">
                                            <mat-form-field>
                                                <mat-label>Longitude</mat-label>
                                                <input matInput formControlName="longitude" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <div id="googleMap" style="width:100%;height:300px;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-address -->

                        <div id="wilcity-addevent-virtual"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Virtual Event</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <section class="section-mat-form-field ">
                                        <mat-checkbox color='primary' formControlName="is_virtual"
                                            (change)="onChangeVirtual($event)">
                                            Virtual
                                        </mat-checkbox>
                                    </section>
                                    <mat-form-field *ngIf="eventForm.get('is_virtual').value">
                                        <mat-label>Youtube URL</mat-label>
                                        <input [required]="isVirtual" matInput formControlName="youtube_url" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-virtual -->

                        <div id="wilcity-addevent-organizer"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Organizer Details</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <div formArrayName="organizers" class="field_module__1H6kT field_style2__2Znhe">

                                        <div *ngFor="let organizer of eventForm.get('organizers')['controls']; index as i"
                                            class="field-has-close">
                                            <div class="row">
                                                <div class="col-xs-12 col-sm-12">
                                                    <div class="field_module__1H6kT field_style2__2Znhe mb-15">
                                                        <mat-form-field>
                                                            <mat-label>Select Organizer</mat-label>
                                                            <mat-select required
                                                                (openedChange)="onSelectOpen($event, eventOrganizerFilterInput)"
                                                                [formControl]="organizer">
                                                                <input class="selectSearch" #eventOrganizerFilterInput
                                                                    matInput placeholder="Search Organizer" />
                                                                <mat-option
                                                                    *ngFor="let option of filteredDropdownOptions(eventOrganizerFilterInput.value, 'oranizers')"
                                                                    [value]="option.value">
                                                                    {{option.viewValue}}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                    <a (click)="removeOrganizerField(i)"
                                                        class="wil-btn--remove wil-btn--close wil-btn mb-15 wil-btn--gray wil-btn--round wil-btn--xs wil-btn--icon">
                                                        <i class="la la-close"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <a (click)="addOrganizerField()"
                                            class="wil-btn mb-5 wil-btn--gray wil-btn--round wil-btn--xs">
                                            Add More
                                        </a>
                                        <a (click)="openOrganizerModal()"
                                            class="wil-btn mb-5 btn-new-organizer wil-btn--gray wil-btn--round wil-btn--xs">
                                            Create New Organizer
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-organizer -->

                        <div id="wilcity-addevent-website_url"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Event Website</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <mat-form-field>
                                        <mat-label>External Link</mat-label>
                                        <input matInput formControlName="website_url" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-website_url -->

                        <div id="wilcity-addevent-tickets"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Tickets</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <div class="tribe_community_edit">
                                        <div class="tribe-community-events form">
                                            <div
                                                class="tribe-section tribe-section-tickets tribe-image-uploads-enabled">
                                                <div id="tribe_panel_base" class="ticket_panel panel_base">
                                                    <div *ngIf="eventForm.get('tickets').value.length > 0 || eventForm.get('rsvp').value.length > 0"
                                                        class="tribe_sectionheader ticket_list_container">
                                                        <!-- <div class="ticket_table_intro">
                                                            <span id="ticket_form_total_capacity">
                                                                Total Event Capacity: <span
                                                                    id="ticket_form_total_capacity_value">
                                                                    38 </span>
                                                            </span>

                                                            <a href="#" class="button-secondary">
                                                                View Orders </a>
                                                            <a class="button-secondary" href="#">
                                                                View Attendees </a>
                                                        </div> -->


                                                        <table id="tribe_ticket_list_table"
                                                            class="tribe-tickets-editor-table eventtable ticket_list eventForm widefat fixed">
                                                            <thead>
                                                                <tr class="table-header">
                                                                    <th class="ticket_name column-primary">Tickets</th>
                                                                    <th class="ticket_price">Price</th>
                                                                    <th class="ticket_capacity">Capacity</th>
                                                                    <th class="ticket_available">Available</th>
                                                                    <th class="ticket_edit"></th>
                                                                </tr>
                                                            </thead>

                                                            <!-- show tickets -->
                                                            <tbody formArrayName="tickets"
                                                                class="tribe-tickets-editor-table-tickets-body ui-sortable">

                                                                <tr *ngFor="let ticket of eventForm.get('tickets')['controls']; index as i"
                                                                    [formGroupName]="i"
                                                                    class="Tribe__Tickets_Plus__Commerce__WooCommerce__Main is-expanded">
                                                                    <td
                                                                        class="column-primary ticket_name Tribe__Tickets_Plus__Commerce__WooCommerce__Main">
                                                                        {{ticket.get('title').value}}
                                                                    </td>

                                                                    <td class="ticket_price" data-label="Price:">
                                                                        <span
                                                                            *ngIf="ticket.get('price').value; else freeTicket"
                                                                            class="woocommerce-Price-amount amount"><bdi><span
                                                                                    class="woocommerce-Price-currencySymbol">£</span>{{ticket.get('price').value}}</bdi></span>
                                                                        <ng-template #freeTicket>
                                                                            <span>Free</span>
                                                                        </ng-template>
                                                                    </td>

                                                                    <td class="ticket_capacity">
                                                                        <span class="tribe-mobile-only">Capacity:</span>
                                                                        {{ ticket.get('capacity').value ?
                                                                        ticket.get('capacity').value :
                                                                        'Unlimited' }}
                                                                    </td>

                                                                    <td class="ticket_available">
                                                                        <span
                                                                            class="tribe-mobile-only">Available:</span>
                                                                        {{ ticket.get('capacity').value ? (
                                                                        ticket.get('available') ?
                                                                        ticket.get('available').value :
                                                                        ticket.get('capacity').value ) : 'Unlimited' }}
                                                                    </td>

                                                                    <td class="ticket_edit">
                                                                        <button
                                                                            (click)="openTicketModal(ticket.value, i)"
                                                                            type="button" class="ticket_edit_button">
                                                                            <i class="fa fa-pencil"></i>
                                                                        </button>
                                                                        <button
                                                                            (click)="removeEventTicket(i, ticket.value)"
                                                                            type="button"
                                                                            class="ticket_edit_button ticket_delete_button">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                            <!-- show rsvp -->
                                                            <tbody formArrayName="rsvp">
                                                                <tr *ngFor="let rsvp of eventForm.get('rsvp')['controls']; index as i"
                                                                    [formGroupName]="i"
                                                                    class="Tribe__Tickets__RSVP is-expanded">
                                                                    <td
                                                                        class="column-primary ticket_name Tribe__Tickets__RSVP">
                                                                        {{rsvp.get('title').value}}
                                                                    </td>

                                                                    <td class="ticket_price" data-label="Price:">
                                                                        FREE</td>

                                                                    <td class="ticket_capacity">
                                                                        <span class="tribe-mobile-only">Capacity:</span>
                                                                        {{ rsvp.get('capacity').value ?
                                                                        rsvp.get('capacity').value :
                                                                        'Unlimited' }}
                                                                    </td>

                                                                    <td class="ticket_available">
                                                                        <span
                                                                            class="tribe-mobile-only">Available:</span>
                                                                        {{ rsvp.get('capacity').value ? (
                                                                        rsvp.get('available') ?
                                                                        rsvp.get('available').value :
                                                                        rsvp.get('capacity').value ) : 'Unlimited' }}
                                                                    </td>

                                                                    <td class="ticket_edit">
                                                                        <button (click)="openRsvpModal(rsvp.value, i)"
                                                                            type="button" class="ticket_edit_button">
                                                                            <i class="fa fa-pencil"></i>
                                                                        </button>
                                                                        <button (click)="removeEventRsvp(i, rsvp.value)"
                                                                            type="button"
                                                                            class="ticket_edit_button ticket_delete_button">
                                                                            <i class="fa fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>

                                                        </table>

                                                    </div>

                                                    <div class="tribe-ticket-control-wrap">

                                                        <button (click)="openTicketModal()" type="button"
                                                            class="button-secondary ticket_form_toggle">
                                                            New ticket </button>

                                                        <button (click)="openRsvpModal()" type="button"
                                                            id="rsvp_form_toggle"
                                                            class="button-secondary ticket_form_toggle">
                                                            New RSVP </button>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-tickets -->

                        <div id="wilcity-addevent-website_url"
                            class="content-box_module__333d9 content-box_lg__3v3a- enable">
                            <header class="content-box_header__xPnGx clearfix">
                                <div class="wil-float-left">
                                    <h4 class="content-box_title__1gBHS">
                                        <span>Event Meta Data</span>
                                    </h4>
                                </div>
                            </header>
                            <div>
                                <div class="content-box_body__3tSRB">
                                    <div class="row mt-10">
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Meta Title</mat-label>
                                                <input matInput formControlName="meta_title" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Meta Keywords</mat-label>
                                                <input matInput formControlName="meta_keywords" />
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-form-field>
                                                <mat-label>Meta Description</mat-label>
                                                <textarea matInput formControlName="meta_desc" rows="5"></textarea>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><!-- wilcity-addevent-website_url -->

                        <p *ngIf="showError" class="errorMessage">{{ errorMessage }}</p>

                        <button mat-raised-button
                            class="wil-btn wil-btn--primary wil-btn--round wil-btn--lg wil-btn--block" color="primary"
                            type="submit" [disabled]="eventForm.invalid">
                            Submit Event
                        </button>


                    </form>
                </div>
            </div>
        </div>
    </section>
</div>